/**
 * Le SCHEDE della sezione Avatar (I-635/I-636, variante A di Luca): quali sono, in che ordine, dove portano. Puro: nessun `env`, nessun hook, cosi'
 * la regola «quali schede si vedono» si prova senza montare niente (`tests/avatar-schede-elenco.test.ts`).
 *
 * Ordine e rotte: I miei · Esplora · Emote · Negozio · Editor → `/avatars`, `/avatars/esplora`, `/avatars/emotes`, `/avatars/negozio`, `/avatars/studio`.
 * «Emote» e «Negozio» ci sono solo coi LORO flag, «Editor» solo per chi puo' creare (`usePuoCreareAvatar`): senza ruolo sono QUATTRO.
 * ⚠️ «Quali si vedono» non e' «quali rotte esistono»: le rotte e i loro cancelli sono del router (e di `CreatoreGate`), qui si decide solo la riga.
 */
export type SchedaAvatar = 'mine' | 'explore' | 'emotes' | 'shop' | 'studio';

export const ROTTA_SCHEDA: Readonly<Record<SchedaAvatar, string>> = {
  mine: '/avatars',
  explore: '/avatars/esplora',
  emotes: '/avatars/emotes',
  shop: '/avatars/negozio',
  studio: '/avatars/studio',
};

export interface SchedeAccese {
  /** Il flag delle emote (le DUE letture: `env` e il confronto letterale), calcolato da chi chiama. */
  emote: boolean;
  /** Il flag del negozio, idem. */
  negozio: boolean;
  /** `usePuoCreareAvatar()`. */
  editor: boolean;
}

export function schedeVisibili({ emote, negozio, editor }: SchedeAccese): SchedaAvatar[] {
  const l: SchedaAvatar[] = ['mine', 'explore'];
  if (emote) l.push('emotes');
  if (negozio) l.push('shop');
  if (editor) l.push('studio');
  return l;
}

/**
 * Quante schede per riga, a righe BILANCIATE (I-809): `righe = ceil(n / massimo)`, `perRiga = ceil(n / righe)`. Fino a `massimo` schede e' UNA riga con tutte
 * (invariata); con sei, 3 + 3 e non 5 + 1, che lasciava una scheda sola sulla seconda riga. Il `massimo` e' la capienza MISURATA di una riga (`SCHEDE_PER_RIGA`).
 * ⚠️ Limite: righe tutte uguali tranne l'ultima, quindi da 21 schede in su (5+5+5+5+1) una scheda puo' restare sola; le schede oggi sono al piu' sei.
 */
export function schedePerRiga(n: number, massimo: number): number {
  if (n <= 0 || massimo <= 0) return Math.max(1, massimo);
  return Math.ceil(n / Math.ceil(n / massimo));
}
